import { EmptyState } from "@go-novus/ui";

import * as m from "#/paraglide/messages";

/**
 * 地址不在 /stores/<店铺>/ 前缀下时整屏就这一个提示：
 * 后台按店铺隔离，没有店铺段就没有可绑定的会话，只能请商家从
 * Shopify 后台打开。这里不列店、不猜店。
 */
export function StoreEntryPrompt() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--bg-page-body)] p-4">
      <EmptyState
        heading={m.store_entry_heading()}
        body={m.store_entry_body()}
      />
    </main>
  );
}
